module.exports = __webpack_public_path__ + "img/public/TrustIcons/Google.svg?6b212c77";